export default __webpack_public_path__ + "static/media/faq_dog.a3e00828.png";